import { HTTP } from './httpCommon';

export const httpPut = {

  ////////////////////////////////////////////
  ///ACCOUNTS
  ////////////////////////////////////////////

  //Update Account
  updateAccount(account, callback) {
    HTTP.put('Accounts/' +
      account.id, account
    )
      .then(response => {
        callback(response.status)
      })
      .catch(e => {
        //this.errors.push(e)
        console.log(e);
      })

  },

  ////////////////////////////////////////////
  ///INCOMES
  ////////////////////////////////////////////

  //Update Income
  updateIncome(income, callback) {
    HTTP.put('Incomes/' +
      income.id, income
    )
      .then(response => {
        callback(response.status)
      })
      .catch(e => {
        //this.errors.push(e)
        console.log(e);
      })

  },


  ////////////////////////////////////////////
  ///EXPENSES
  ////////////////////////////////////////////

  //Update Expenses
  updateExpense(expense, callback) {
    HTTP.put('Expenses/' +
      expense.id, expense
    )
      .then(response => {
        callback(response.status)
      })
      .catch(e => {
        //this.errors.push(e)
        console.log(e);
      })

  },


  ////////////////////////////////////////////
  ///BUDGETS
  ////////////////////////////////////////////

  //Update Budgets
  updateBudget(budget, callback) {
    HTTP.put('Budgets/' +
      budget.id, budget
    )
      .then(response => {
        callback(response.status)
      })
      .catch(e => {
        //this.errors.push(e)
        console.log(e);
      })

  },

  


}



// WEBPACK FOOTER //
// ./src/api/httpPut.js